import { Dropdown } from 'primereact/dropdown';
import { useGitRequest } from '../../Hooks/Features/HelpDesk/useGitRequest';
import { useCommon } from '../../Hooks/Common/useCommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'underscore';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';

const GitRequest = ({ projectOpts, setShowRequestPopup, callApi, editData, setEditData }) => {

    const { popupFilters, setPopupFilters, tagRef, handleRequestSubmit, spin, options } = useGitRequest({ projectOpts, setShowRequestPopup, callApi, editData, setEditData })

    const { checkPermission } = useCommon()
    return (

        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "devops", "data": "new_existing_btn"}'>
                <div className="d-flex gap-1 mt-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <input
                            type="radio"
                            id="existing"
                            name="request"
                            value={0}
                            onChange={(e) => setPopupFilters((prev) => ({ ...prev, create_request_type: 0 }))}
                            checked={popupFilters.create_request_type === 0}
                            style={{ marginLeft: 0 }}
                        />
                        <label htmlFor="existing">
                            Existing
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <input
                            type="radio"
                            id="new"
                            name="request"
                            value={1}
                            onChange={(e) => setPopupFilters((prev) => ({ ...prev, create_request_type: 1 }))}
                            checked={popupFilters.create_request_type === 1}
                        />
                        <label htmlFor="new">
                            New
                        </label>
                    </div>
                </div>
            </div>
            <div className="w30 mt-2">
                <div className="mt-2">Project Name</div>
                <Dropdown className="input-dd" options={projectOpts} optionLabel="project_name" value={popupFilters.project} onChange={(e) => setPopupFilters((prev) => ({ ...prev, project: e.target.value, "approve_by": 0, }))} placeholder="Project" filter filterInputAutoFocus />
            </div>
            {popupFilters.create_request_type === 0 ?
                <div>
                    <div className="mt-2">Git Repo</div>
                    <div>
                        <MultiSelect options={options?.repoDetails} optionLabel="repo_url" display="chip" value={popupFilters?.repo} onChange={(e) => setPopupFilters((prev) => ({ ...prev, repo: e.target.value }))} placeholder="Select repository" style={{ height: "auto" }} filter filterInputAutoFocus
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'repo', popupFilters.repo, (val) => setPopupFilters((prev) => ({ ...prev, repo: val })), () => { })} />
                    </div>
                </div> :
                <div>
                    <div>
                        <div className="mt-2">Git Groups</div>
                        <div>
                            {!_.isEmpty(editData) && popupFilters?.git_group?.repo_group_name?.toLowerCase()?.trim() === "new group" ?
                                <input className="w100 form-control border" placeholder="Enter Git Group Name" value={popupFilters.group_name} onChange={(e) => setPopupFilters((prev) => ({ ...prev, group_name: e.target.value }))} /> :
                                <Dropdown options={options?.gitGroups || []} optionLabel="repo_group_path" value={popupFilters.git_group} onChange={(e) => setPopupFilters((prev) => ({ ...prev, git_group: e.target.value }))} className="input-dd" placeholder="Select Git Group" filter filterInputAutoFocus />
                            }
                        </div>
                    </div>
                    <div className="mt-2">Git Repo</div>
                    <div>
                        <input className="w100 form-control border" placeholder="Enter Git Repo Name" value={popupFilters.repo_name} onChange={(e) => setPopupFilters((prev) => ({ ...prev, repo_name: e.target.value }))} />
                    </div>
                </div>
            }
            {popupFilters.create_request_type === 0 && options?.roleDetails?.length > 0 &&
                <div>
                    <div className="mt-2">Role</div>
                    <div className="d-flex gap-1" >
                        {options?.roleDetails.map((role) => (
                            <div key={role?.request_type_roles_id} className={`border p-2 rounded help-desk-popup-roles ${popupFilters?.role?.request_type_roles_id === role?.request_type_roles_id ? "helpdesk-popup-role-active" : ""}`} onClick={() => setPopupFilters((prev) => ({ ...prev, role: role }))}>
                                <span><FontAwesomeIcon icon="fa-solid fa-user-secret" /> {role.request_role_name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            }
            {options?.approveBy?.length > 0 &&
                <div>
                    <div className="mt-2">Approve By</div>
                    <div className="d-flex gap-1 mt-2" >
                        {options?.approveBy.map((item) => (<div>
                            {item.user_code !== null &&
                                <div key={item?.user_code} className="d-flex align-items-center">
                                    <input type="radio" id={item?.user_code} name="approve_by" value={item?.user_code} onChange={(e) => setPopupFilters((prev) => ({ ...prev, approve_by: e.target.value }))} checked={parseInt(item?.user_code) === parseInt(popupFilters?.approve_by)} />
                                    <label htmlFor={item?.user_code} name="approve_by">{item.user_display_name}</label>
                                </div>
                            }
                        </div>
                        ))}
                    </div>
                </div>
            }
            <div className="mt-2">Reason for access</div>
            <div>
                <textarea rows={2} placeholder="Write reason for access" className="w100 form-control border" value={popupFilters.reason} onChange={(e) => setPopupFilters((prev) => ({ ...prev, reason: e.target.value }))} />
            </div>
            <div className="d-flex justify-content-between">
                {popupFilters.reason?.trim()?.split(" ")?.length > 5 ? <span></span> :
                    <span>{popupFilters.reason?.split(" ")?.[0]?.length === 0 ? 0 : popupFilters.reason?.trim()?.split(" ")?.length}/5 words</span>
                }
                <div className="d-flex justify-content-end align-items-center mt-3">
                    <button className="button btn-default" onClick={() => { setShowRequestPopup(false); setEditData({}) }}>Cancel</button>
                    {
                        spin ? <button className="button btn-primary" style={{ width: "60px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className="button btn-primary" onClick={handleRequestSubmit}>Submit</button>
                    }

                </div>
            </div>
        </div>
    )
}

export default GitRequest